<template>
    <div :ref="stepName" style="position:relative">
        <div class="form-header satisfaction">
            <p>Grâce à notre <span>offre découverte</span>, si vous êtes satisfait de votre abonnement après 6 mois :</p>
            <ul class="satisfaction-result-list">
                <li class="satisfaction-result-list-item" v-for="(item, n) in satisfaction_result" :key="n">
                    <p v-html="item"></p>
                </li>
            </ul>
            <p v-html="optin_text"></p>
            <p></p>
        </div>
        <PaymentOptinForm></PaymentOptinForm>
<!--        <b-button type="button is-primary next-button" :disabled="block_form" v-html="step._button" @click="nextStep()"></b-button>-->
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import form_step_mixin from '../../../form_step_mixin'
import PaymentOptinForm from "./PaymentOptinForm.vue";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: {PaymentOptinForm},
    mixins: [mixin, animation_engine_mixin, animation_step_style_mixin, form_step_mixin],
    data() {
        return {
            satisfaction_result: [
                "Vous serez remboursé de vos 3 premières mensualités à 9,84 €, ce qui correspond à trois mois d’abonnement gratuits.",
                "En plus de cela, dès que vous avez réglé votre deuxième mensualité, vous pourrez déjà sélectionner un cadeau parmi notre vaste gamme de plus de cent produits. Que vous soyez amateur de high-tech, d'articles pour la maison ou d’accessoires pratiques, il y a forcément un cadeau qui vous conviendra !",
                "Vous continuez à profiter de votre abonnement, mais à un tarif réduit de 50%",
            ],
            optin_text: "J'autorise Testachats à encaisser, par le débit de mon compte bancaire, les 9,84 € par mois (prix valable pendant un an au lieu de 19,68 €). À l'issue de cette période, mon abonnement sera automatiquement reconduit, et ce, jusqu'à la révocation expresse de mon affiliation. Après 6 mois, vous serez remboursé de vos 3 premières mensualités à 9,84 €, ce qui correspond à trois mois d'abonnement gratuits."
        }
    }
}
</script>
